import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import service_users from 'services/users';

/**
 * @typedef {Object} SubmitProductFeedbackVariables
 * @property {string} feedbackTitle - Brief summary of the feedback
 * @property {string} feedbackText - Detailed feedback text
 * @property {string} url - Current page URL
 */

/** @typedef {Omit<UseMutationOptions<Object, Error, SubmitProductFeedbackVariables, unknown>, 'mutationKey' | 'mutationFn'>} UseSubmitProductFeedbackMutationOptions */

/**
 * @param {UseSubmitProductFeedbackMutationOptions} [options={}]
 */
export const useSubmitProductFeedbackMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['submit-product-feedback'],
        /** @param {SubmitProductFeedbackVariables} variables */
        mutationFn: variables => service_users.submitProductFeedback(variables)
    });
};
